
import { DefaultState } from 'store/types';

export const DELETE_ROOM_REQUEST = 'DELETE_ROOM_REQUEST';
export const DELETE_ROOM_SUCCESS = 'DELETE_ROOM_SUCCESS';
export const DELETE_ROOM_FAILURE = 'DELETE_ROOM_FAILURE';

export interface DeleteRoomParams {
  doNotSendNotificationToAssociate: boolean;
  doNotSendNotificationToCLC: boolean;
  providerSendNotification?: boolean;
  reservationProviderId: string;
};

export interface DeleteRoomData {

};

export type DeleteRoomState = DefaultState & {
  contents?: DeleteRoomData;
};

interface DeleteRoomDataRequest {
  type: typeof DELETE_ROOM_REQUEST;
};

interface DeleteRoomDataSuccess {
  type: typeof DELETE_ROOM_SUCCESS,
  contents: DeleteRoomData;
}

interface DeleteRoomDataFailure {
  type: typeof DELETE_ROOM_FAILURE;
}

export type DeleteRoomActionTypes = DeleteRoomDataRequest | DeleteRoomDataSuccess | DeleteRoomDataFailure;